export default __webpack_public_path__ + "static/media/our-story-img12.be987e9d.jpg";